import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-circle",
  "use": "icon-arrow-right-circle-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 35 35\" id=\"icon-arrow-right-circle\">\r\n<path d=\"M17.5,35C7.9,35,0,27.1,0,17.5S7.9,0,17.5,0S35,7.9,35,17.5S27.1,35,17.5,35z M17.5,5C10.6,5,5,10.6,5,17.5\r\n\tS10.6,30,17.5,30S30,24.4,30,17.5S24.4,5,17.5,5z M16.3,26.4l-3.6-3.5l5.4-5.4L12.6,12l3.5-3.5l9,9L16.3,26.4z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/arrow-right-circle.svg
// module id = 262
// module chunks = 0 1